import React, { useContext, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import flv from "flv.js";
// import { fetchStream } from "../../actions";
import { fetchStream } from ".././../action";
import { getUserDetail } from "../../constants/function";
import { SocketContext } from "../../context/socket";
import { OBS_CHANNEL_URL } from "../../constants/api";

const userData = getUserDetail();

export default function StreamShow({ obsUrl, fromObs, channelName }) {
  const videoRef = useRef(null);
  let player = useRef(null);
  const { count } = useSelector((state) => state.adv);
  console.log("fromObs=", fromObs, "obsUrl=", obsUrl);
  const socket = useContext(SocketContext).Socket;
  const [flip, setFlip] = React.useState(false);

  useEffect(() => {
    if (socket) {
      socket.on("video-flip-true", function (data) {
        if (data.channelName === channelName && data.isflip) {
          setFlip(true);
        } else {
          setFlip(false);
        }
      });
    }
  }, [socket, channelName]);

  useEffect(() => {
    fetchStream(channelName);
    buildPlayer();

    return () => {
      if (player.current) {
        player.current.destroy();
      }
    };
  }, [channelName]);

  const buildPlayer = () => {
    if (!channelName && !fromObs) {
      return;
    }
    if (player.current) {
      return;
    }
    const url = fromObs
      ? `${obsUrl}.flv`
      : `${OBS_CHANNEL_URL}/${channelName}.flv`;

    console.log( "** FLV URL: " + url );

    player.current = flv.createPlayer({
      type: "flv",
      url: url,
    });

    player.current.attachMediaElement(videoRef.current);
    player.current.load();
  };

  useEffect(() => {
    if (count) {
      videoRef.current.muted = true;
    } else {
      videoRef.current.muted = false;
    }
  }, [count]);
  // console.log("channelName", channelName);
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        backgroundColor: "black",
      }}
    >
      <video
        ref={videoRef}
        style={{
          width: "100%",
          height: "100%",
          // objectFit: "cover",
          // backgroundColor: "black",
          position: "absolute",
          left: "0px",
          top: "0px",
          transform: !flip ? "rotateY(180deg)" : "",
          objectFit: "contain",
        }}
        // controls
        autoPlay
      />
    </div>
  );
}
